var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57143 1H2.42857C2.04969 1 1.68633 1.15051 1.41842 1.41842C1.15051 1.68633 1 2.04969 1 2.42857V13.2414C1.00002 13.304 1.01646 13.3654 1.04769 13.4196C1.07891 13.4738 1.12381 13.5188 1.17791 13.5502C1.232 13.5816 1.29339 13.5982 1.35594 13.5985C1.41848 13.5987 1.47998 13.5824 1.53429 13.5514L5.29143 11.405C5.50723 11.2817 5.75147 11.2169 6 11.2169C6.24853 11.2169 6.49276 11.2817 6.70857 11.405L10.4657 13.5521C10.5201 13.5832 10.5816 13.5994 10.6442 13.5992C10.7068 13.5989 10.7683 13.5822 10.8224 13.5508C10.8765 13.5193 10.9214 13.4741 10.9526 13.4199C10.9838 13.3656 11.0001 13.304 11 13.2414V2.42857C11 2.04969 10.8495 1.68633 10.5816 1.41842C10.3137 1.15051 9.95031 1 9.57143 1Z",
    stroke: "#51CDA0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveGreen);
export default __webpack_public_path__ + "static/media/saveGreen.59b37475c77e79bc1d7c42f796b9e012.svg";
export { ForwardRef as ReactComponent };